<template>
  <div class="container">
      <h1>CLEAN VIN</h1>
      <div class="col my-4">
                <h2 class="message">To perform a factory reset enter your VIN</h2>
                <p>
                    <label class="message" for="vin">VIN</label>
                    <input class="form-control"
                        id="vin"
                        v-model="vin"
                        type="text"
                        name="vin">
                </p>
                <p>
                    <label class="message" for="guid">GUID</label>
                    <input class="form-control"
                        id="guid"
                        v-model="guid"
                        type="text"
                        name="guid">
                </p>
                <p>
                    <label class="message" for="token">Auth Token</label>
                    <input class="form-control"
                        id="token"
                        v-model="token"
                        type="text"
                        name="token">
                </p>
                <div class="form-group">
                    <label >Select Environment</label>
                    <select class="form-control" id="environmentSelect" v-model="environmentSelect">
                        <option>DEV</option>
                        <option>QA</option>
                        <option>STG</option>
                        <option>STG-IF</option>
                        <option>PREPROD</option>
                    </select>
                </div>
                <div v-if='guid'>
                    <p>
                    {{guid}}
                    {{vin}}
                    {{output}}
                    </p>
                </div>
                
                <div class="py-3" style="text-align: center">
                    <button class="ty-button" v-on:click="cleanVin">Send VIN</button>
                </div>
            </div>
  </div>
</template>

<script>
export default {
    name:'cleanvin',
    data: function(){
        return {
            vin:'',
            guid:'',
            token:'',
            output:'',
            env:{
                DEV:'dev',
                QA:'qa',
                STG:'stg',
                STGIF:'stg-if',
                PREPROD:'preprod'
            },
            environmentSelect: ''
        }

    },
    methods: {
        cleanVin: function(){
            console.log("environment select: ", this.environmentSelect)
            console.log('environment url: ', this.env[this.environmentSelect])
            if(this.environmentSelect != null){
                var data = JSON.stringify({
                    "guid":this.guid,
                    "vin":this.vin,
                    "status":"SOLD",
                    "generation":"21MM"
                });
                
                var config = {
                method: 'put',
                url: `https://oneapi21mm.${this.env[this.environmentSelect]}.telematicsct.com/v1/vehicle-association/vehicle/sold`,
                headers: { 
                    'Authorization': `Bearer ${this.token}`, 
                    'Brand': 'L', 
                    'DATETIME': '1511796583386', 
                    'X-CORRELATIONID': '123e4567-e89b-12d3-a456-426655440001', 
                    'x-api-key': 'FVDkNZAUvy7L5AvGDfFRX5CR98cHAnmo23ghM14b', 
                    'X-LOCALE': 'en-US', 
                    'X-CHANNEL': 'ONEAPP', 
                    'x-guid': 'c6d0db36d43c42d9b1931c6badf19646', 
                    'x-brand': 'T', 
                    'Content-Type': 'application/json'
                },
                data : data
                };

                this.axios(config)
                .then(function (response) {
                    console.log(JSON.stringify(response.data));
                    this.output = JSON.stringify(response.data);
                })
                .catch(function (error) {
                    console.log('Clean VIN Error: ', error);
                    this.output = error;
                });
            }


        }

        
    },
}
</script>

<style>

</style>